import { api } from '../../../services/api'

/**
 * Send email for recovery password.
 *
 * @endpoint POST /api/me/identities/{auth0Id}/forgot_password
 * @scope shared
 * @see https://flecto.dev/api-5836477
 */
export async function userForgotPassword(auth0Id: string): Promise<void> {
  await api.post(`/api/me/identities/${auth0Id}/forgot_password`)
}
